module.exports = __webpack_public_path__ + "static/media/chinese_04.6d7f9e1a.jpg";